import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { router } from '@/router'
import { migrateDbNames } from '@/lib/dbMigration'
import '@/index.css'

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element not found')

// Migrate any data from the old imagevideo-* IndexedDB names before stores initialise
migrateDbNames().catch(() => undefined)

createRoot(rootEl).render(
  <StrictMode>
    <Suspense fallback={<div style={{ background: '#09090b', minHeight: '100vh' }} />}>
      <RouterProvider router={router} />
    </Suspense>
  </StrictMode>,
)
